interface SearchParams {
    [key: string]: string | string[] | null | undefined
}

export function toSearchParams(params: SearchParams): URLSearchParams {
    return setSearchParams(new URLSearchParams(), params)
}

export function setSearchParams(urlParams: URLSearchParams, params: SearchParams): URLSearchParams {
    for (const [key, value] of Object.entries(params)) {
        if (Array.isArray(value)) {
            urlParams.delete(key)
            for (const item of (value as string[]))
                urlParams.append(key, item)
        }
        else if (value !== null && value !== undefined) {
            urlParams.set(key, value)
        }
    }
    return urlParams
}
